import { IRegionShort } from 'api/region/types';
import axios from 'axios';
import { IS_NODE_ENV_DEVELOP, MEMCACHE_PORT } from 'ots-constants';
import { IResortPathInfo } from 'api/resort/types';
import { ICategoryNews } from 'api/home/types';

export const memcacheUrl = `http://localhost:${MEMCACHE_PORT}`;

export const getUrlTranslations = async () => axios.get(`${memcacheUrl}/urls`);
// Remember slugs for fast access
export const cacheResortSlugs = async (paths: Array<IResortPathInfo>) => axios.post(`${memcacheUrl}/resorts`, paths);
export const getResortSlugsCache = async () => axios.get(`${memcacheUrl}/all-resorts`);
export const getResortSlug = async (slug: string) => axios.get(`${memcacheUrl}/resort/${slug}`);

export const cacheRegionSlugs = async (paths: Array<IRegionShort>) => axios.post(`${memcacheUrl}/regions`, paths);
export const getRegionSlugsCache = async () => axios.get(`${memcacheUrl}/all-regions`);
export const getRegionSlug = async (slug: string) => axios.get(`${memcacheUrl}/region/${slug}`);

export const cacheCategoryNewsSlugs = async (paths: Array<ICategoryNews>) => axios.post(`${memcacheUrl}/category`, paths);
export const getCategoryNewsSlugsCache = async () => axios.get(`${memcacheUrl}/all-categories`);
export const getCategoryNewsSlug = async (slug: string) => axios.get(`${memcacheUrl}/category/${slug}`);

export const corsProxy = async <T>(getRequest: string) => {
  if (IS_NODE_ENV_DEVELOP) {
    return axios.get<T>(`${memcacheUrl}/cors?url=${encodeURIComponent(getRequest)}`);
  }
  return axios.get<T>(getRequest);
};

export const cacheProxy = async <T>(getRequest: string) => axios.get<T>(`${memcacheUrl}/proxy?url=${encodeURIComponent(getRequest)}`);
